/* eslint-disabled */

const MessageBoxType = {
  ERROR: 0,
  INFO: 1,
  SUCCESS: 2,
  WARNING: 3,
}

const MessageBoxContent = ({
  type,
  buttons,
  title = '',
  subTitle = '',
  description = '',
  note = '',
  component,
  draggable = false,
  hideCloseButton = false,
  maxWidth,
  maxHeight,
  callback,
}) => {
  return {
    type,
    buttons,
    title,
    subTitle,
    description,
    note,
    component,
    draggable,
    callback,
    hideCloseButton,
    maxWidth,
    maxHeight,
  }
}

export { MessageBoxType }
export default MessageBoxContent

/* eslint-enabled */
